import React, { useEffect } from "react";
import styled from "styled-components";


const MemberListImages = styled.img`
    border-radius: 50%;
    border: 2px solid rgb(17,17,17);
    width: 24px;
    height: 24px;
    position: relative;
`;

export default function Members(members) {
    return members.members.map((item, index) => {
        return(
            <MemberListImages style={{right: index*7}} src={`https://be.namasteapis.com/api/v1/profile-image/${item}`}/>
        )
    })
}

